<ng-container *ngIf="imageUrl$ | async as url">
    <img
        *ngIf="url"
        class="pf-document-file-thumb__img"
        [src]="url"
        [alt]="alt || 'Image'"
        loading="lazy" />
    <div
        *ngIf="!url"
        class="pf-document-file-thumb__placeholder"
        role="img"
        [attr.aria-label]="alt || 'Image'">
        <pf-icon iconType="item" size="md"></pf-icon>
    </div>
</ng-container>
